var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"social-share",on:{"click":_setup.share}},[_vm._v(_vm._s(_setup.isFacebook ? 'Facebook' : 'Twitter'))])
}
var staticRenderFns = []

export { render, staticRenderFns }